<template>
  <BaseCard :heading="supplier.name">
    <Flex
      justify="between"
      align="end"
      :class="$style.card"
    >
      <Flex
        direction="column"
        :gap=".5"
      >
        <BaseText
          v-if="
            useTotalProducts
              ? supplier.amountProducts === 1
              : supplier.amountProductsWithStock === 1
          "
        >
          {{ `${useTotalProducts ? supplier.amountProducts : supplier.amountProductsWithStock} ${$t('global.items.product', 1)}` }}
        </BaseText>
        <BaseText v-else>
          {{ $t('products.products_amount', {
              amount: useTotalProducts
                ? supplier.amountProducts
                : supplier.amountProductsWithStock
            }) }}
        </BaseText>
        <BaseText> {{ $t('global.total_inventory') }}: </BaseText>
        <BaseText>
          {{ filters.currency(supplier.totalInventory) }}
        </BaseText>
      </Flex>
      <Flex>
        <BaseButton
          :loading="loading"
          :disabled="disabled"
          color="inverted"
          @click="$emit('selectSupplier')"
          v-test="'chooseSupplierButton'"
        >
          {{ $t('global.actions.select') }}
        </BaseButton>
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import filters from '@/filters';

export default defineComponent({
  props: {
    supplier: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    useTotalProducts: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectSupplier'],
  setup() {
    return {
      filters,
    };
  },
});
</script>

<style
  lang="scss"
  module
>
.card {
  min-width: 300px;
}
</style>
